(function($) {
	var Routes = Backbone.Router.extend(_.extend({}, App._base, {
		routes: {
			'portfolios/:portfolio': 'portfolio',
			'about': 'about',
			':page': 'page',
			'*actions': 'default'
		},

		NavigationClick: false,

		default: function() {

		},
		about: function() {
			var $s = $('#about'),
				t = $s.offset().top;

			// Add room for the header at the top. We need the header height in the collapsed state.
			t -= 90;

			this.ScrollToT(t);
		},
		page: function(page) {
			var $s = $('#'+page),
				t = $s.offset().top;
			this.ScrollToT(t);
		},

			ScrollToT: function(top) {
				console.log('ScrollToT', top);
				TweenMax.to(window, .5, { scrollTo: { y: top }, ease: Linear.easeInOut,
					onComplete: this.proxy(function() {
						console.log('ScrollToT....complete');
						this.NavigationClick = false;
						App.Events.trigger('navScrollComplete');
					})
				});
			},

		portfolio: function(portfolio) {
			var $p = $('#portfolios'),
				pT = $p.offset().top;

			TweenMax.to(window, .5, { scrollTo: { y: pT }, ease: Linear.easeInOut,
				onComplete: function() {
					console.log('scroll to portfolio complete');
					this.NavigationClick = false;
					App.Events.trigger('navScrollComplete');

					App.Views.Portfolios.navigation.each(function() {
						var $$ = $(this),
							id = $$.prop('id').replace('-portfolio', ''),
							ind = $$.index();

						if (id === portfolio) {
							console.log('scrolling to portfolio');
							App.Views.Portfolios.ScrollToPortfolio(ind);
						}
					});
				}
			});
		},

		InitHomeSensing: function() {
			new Waypoint({
				element: $('#hero'),
				offset: $('#hero').height() * .9,
				handler: this.proxy(function() {
					console.log('home');
					if (!this.NavigationClick) {
						console.log('...home...not navigation click');
						App.Routes.navigate('', false, false);
					}
				})
			});
		},
		InitPageSensing: function() {
			new Waypoint({
				element: $('#about'),
				handler: this.proxy(function() {
					console.log('page sensing...about');
					if (!this.NavigationClick) {
						console.log('....page sensing...about...not navigation click');
						App.Routes.navigate('/about', false, false);
					}
				})
			});
			new Waypoint({
				element: $('#contact'),
				offset: $('.main-header').height() * 1.1,
				handler: this.proxy(function() {
					console.log('page sensing...contact');
					if (!this.NavigationClick) {
						console.log('....page sensing...contact...not navigation click');
						App.Routes.navigate('/contact', false, false);
					}
				})
			});
		},

		initialize: function() {
			// Make each section change the route when it's scrolled to.
			//this.InitHomeSensing();
			//this.InitPageSensing();
		}
	}));

	// App.Routes = new Routes();
	// Backbone.history.start();
})(jQuery);  